import Checkout from 'components/Checkout';
import Coupon from 'types/Coupon';
import CurrencyCode from 'types/CurrencyCode';
import MinimalLayout from 'components/MinimalLayout';
import Plan from 'types/Plan';

type Props = {
  annualPlan: Plan;
  coupon: Coupon;
  currencyCode: CurrencyCode;
  plans: Plan[];
  recurlyPublicKey: string;
  userId: number;
};

export default function CheckoutRoute({ annualPlan, coupon, currencyCode, plans, recurlyPublicKey, userId }: Props) {
  return (
    <MinimalLayout>
      <Checkout
        annualPlan={annualPlan}
        coupon={coupon}
        currencyCode={currencyCode}
        initialPlan={plans[0]}
        recurlyPublicKey={recurlyPublicKey}
        userId={userId}
      />
    </MinimalLayout>
  );
}
